import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';
import type { CountryConfig } from '../../contexts/country-config-context/types';
import type { CountryState } from './country.types';
import type { RootState } from 'store/root-state';

export const selectConfig = (state: CountryState): CountryConfig | undefined => get(state, 'countryConfig');

export const selectFeatureConfig = (state: CountryState, featureName: string): [boolean, Record<string, unknown>] => {
  const config = get(state, 'countryConfig') ?? [];
  const selectedFeatureConfig = config.find((feature) => featureName === feature.name);
  return [!!selectedFeatureConfig, selectedFeatureConfig?.data ?? (emptyObject as Record<string, unknown>)];
};

export const selectCountryConfig = (state: RootState) => selectConfig(get(state, 'country'));
export const selectCountryFeatureConfig = (state: RootState, featureName: string) =>
  selectFeatureConfig(get(state, 'country'), featureName);
